import { makeAutoObservable } from 'mobx'
import { apiClient } from '../service/ApiClient'
import { CreateUserDTO, User } from '../types/models/User'
import { LoginUserDTO } from './dto/createUser.dto'
import { toast } from 'react-toastify'
import { userFioToString } from '../helpers/userFioToString'

export class AuthStore {
  isAuth = false
  isAdmin = false
  token = ''
  user: User | undefined
  blockAdmin = false
  constructor() {
    makeAutoObservable(this)
  }

  async login(dto: LoginUserDTO) {
    const { data } = await apiClient.post('/auth/login', dto)
    this.saveToken(data)
  }

  async register(dto: CreateUserDTO) {
    console.log(`Registered: ${dto.username}`)
    const { data } = await apiClient.post('/auth/registration', dto)
    this.saveToken(data)
  }

  async saveToken(data: { token: string; user: User }, onSession?: boolean) {
    this.isAdmin = false
    this.isAuth = true
    this.token = data.token
    this.user = data.user

    apiClient.defaults.headers.common['Authorization'] = `Bearer ${data.token}`
    toast.info(`Добро пожаловать ${userFioToString(data.user, true)}`)
    if (!onSession) {
      localStorage.setItem('token', this.token)
    } else {
      this.blockAdmin = true
    }
  }

  async logout() {
    this.isAuth = false
    this.isAdmin = false
    this.blockAdmin = false
    this.token = ''
    this.user = undefined
    localStorage.removeItem('token')
    localStorage.removeItem('admin')
    apiClient.defaults.headers.common['Authorization'] = ''

    // window.location.reload()
  }

  async init() {
    const token = localStorage.getItem('token')
    if (!token) return

    try {
      const { data } = await apiClient.get('/auth', {
        headers: { Authorization: `Bearer ${token}` },
      })
      apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`

      this.user = data
      this.isAuth = true
      if (localStorage.getItem('admin')) this.checkAdmin()
    } catch (error) {
      this.isAuth = false
      this.isAdmin = false
    }
  }

  async checkAdmin() {
    if (this.blockAdmin)
      throw new Error(`Невозможно зайти в админ меню по ключу`)
    try {
      await apiClient.get('/auth/admin')

      this.isAdmin = true
      localStorage.setItem('admin', 'ok')
    } catch (error: any) {
      this.isAdmin = false
      localStorage.removeItem('admin')
      // Если надо показать код ошибки в тосте
      // throw new Error(error)
      throw new Error('Нет доступа для операции Обратитесь к Администратору')
    }
  }
}
